<template>
<Card :bordered="false" :padding="0" dis-hover>
     <p  @click="toggle" style="cursor:pointer;" >
        <Row type="flex" justify="start" align="middle" style="margin-top:14px;margin-bottom:14px">
            <CommonIcon type='_custom-pack' v-show="showGrid" size="14"/>  <CommonIcon  v-show="!showGrid" type='_custom-spread' size="14"/> <span style="margin-left:10px;font-size: 14px;font-weight:bold" v-text="myConfig.title" />
        </Row>
     </p>
     <div style="padding-left:24px">
        <Divider style="margin-top:0px;margin-bottom:10px;"/>
        <div v-show="showGrid">
            <SimpleViewGrid ref="grid" :config="myConfig"></SimpleViewGrid>
        </div>
    </div>
</Card>
</template>
<script>
export default {
    name: 'operlog',
    data () {
        return {
            myConfig:{
                dynamicHeight:false,
                resources:'mss',
                height:360,
                title:'操作日志',
                method:'mss.work.operationlog.search',
                generalOrientation:true,
                searchParam:{
                    order_field: 'operdate',
                    order_direction: 'desc'
                },
                response:'operation_log',
                items:[{
                    label:'操作类型',
                    name:'opertype',
                    type:'ComboBox',
                    data:[{
                        code:'U',name:'修改'
                    }, {
                        code:'I',name:'新增'
                    }, {
                        code:'D',name:'删除'
                    }],
                    codeWithName:false,
                    width:100
                },{
                    label:'操作日期',
                    name:'operdate',
                    type:'DateBox',
                    vtype:'datetime',
                    width:150
                }, {
                    label:'操作人',
                    name:'username',
                    type:'TextBox',
                    width:150
                }, {
                    label:'操作内容',
                    name:'memo',
                    type:'TextBox',
                    tooltip:true
                }]
            },
            showGrid:true,
            billno:''
        };
    },
    created() {
        this.myConfig = Object.assign({}, this.myConfig, this.config);
        this.myConfig.resources = this.OmdUrl[this.myConfig.resources];;
        this.showGrid = true;
    },
    props:{
        config: {
            type:Object,
            default:null
        }
    },
    methods: {
        setData(value) {
            this.refurbish(value);
        },
        clearData() {
            this.billno = '';
            this.$refs.grid.clearData();
        },
        toggle () {
            this.showGrid = !this.showGrid;
        },
        setShowGrid(value) {
            this.showGrid = value;
        },
        refurbish (value) {
            if (value) {
                let para = {};
                para.billno = value;
                this.billno = value;
                this.$refs.grid.clearSearchBeforeSearchParam();
                this.$refs.grid.setSearchBeforeSearchParam(para);
                this.$refs.grid.refurbish();
            } else {
                this.billno = '';
                this.$refs.grid.clearSearchBeforeSearchParam();
                this.$refs.grid.clearData();
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/masterplate/operlog.vue